/* eslint-disable css-modules/no-unused-class */
import { useDispatch, useSelector } from 'react-redux';

// Design System
import cardImage from 'jl-design-system/assets/images/gift-options/gift-voucher-regular.svg';

// Types
import { AppDispatch } from 'types/RootState.types';

// Config
import applyGiftVoucherState from './ApplyGiftVoucher.state';
import paymentTypeConstants from '../../constants/paymentTypeConstants';
import { applyGiftVoucher } from '../../redux/actions/payment/applyGiftVoucherAction';
import { giftVouchersSelector } from '../../redux/reducers/payment/giftVoucherReducer';
import { applyGiftVoucherFormConfig } from '../../utils/form/configs/giftOptions';

// Components
import ApplyGenericGiftOption from './ApplyGenericGiftOption';

// Styles
import styles from './apply-gift-options-forms.scss';
import { ApplyGiftVoucherProps } from './ApplyGiftVoucher.types';

const formConfig = applyGiftVoucherFormConfig();

const ApplyGiftVoucher = ({
  onDone = () => {},
  onRemove = () => {},
  onUndo = () => {},
  renderingContext = '',
}: ApplyGiftVoucherProps) => {
  const dispatch: AppDispatch = useDispatch();
  const {
    applyGiftPaymentFailed,
    errorMessage,
    formSubmitFailed,
    payments = [],
    isGiftVoucherAmountZero,
    isLoading,
    outstandingBalance = '',
    removeGiftOptionLoading,
    values = {},
  } = useSelector(applyGiftVoucherState);
  const giftVouchersList = giftVouchersSelector(payments, renderingContext);

  const onDoneClickHandler = () => {
    if (!formSubmitFailed || Object.keys(values).length === 0) {
      onDone();
    }
  };

  const onFormSubmitHandler = (formValues: { giftVoucherSecurityCode: string; giftVoucherSerialNumber: string }) => {
    const { giftVoucherSecurityCode: securityCode, giftVoucherSerialNumber: serialNumber } = formValues;
    return dispatch(applyGiftVoucher({ serialNumber, securityCode }));
  };

  return (
    <ApplyGenericGiftOption
      applyGiftPaymentFailed={applyGiftPaymentFailed}
      cardImage={cardImage}
      doneButtonDataTest="apply-gift-voucher-button-done"
      doneButtonText="Done"
      errorMessage={errorMessage}
      formConfig={formConfig}
      formContainerClassName={styles.giftVoucherFormContainer}
      formDataTest="gift-voucher-form"
      formSubmitFailed={formSubmitFailed}
      hiddenAlertSubmittingText="Please wait, Gift voucher is submitting"
      instructionalText="Enter the 7-letter security code (scratch-off panel) and the 10-digit serial number."
      instructionalTextDataTest="gift-voucher-instructional-text"
      isLoading={isLoading}
      isZeroAmount={isGiftVoucherAmountZero}
      items={giftVouchersList}
      onDoneClick={onDoneClickHandler}
      onFormSubmit={onFormSubmitHandler}
      onRemove={onRemove}
      onUndo={onUndo}
      outstandingBalance={outstandingBalance}
      removeGiftOptionLoading={removeGiftOptionLoading}
      type={paymentTypeConstants.GIFT_VOUCHER}
    />
  );
};

export default ApplyGiftVoucher;
